import { useEffect } from 'react';

/**
 * Pone el iso del productor como favicon mientras se ve el micrositio, y deja
 * el de Puja al salir.
 *
 * Lo monta `SiteHeader`, así que vale para las cinco páginas del remate sin
 * tocar cada una. Sin `url` no hace nada: queda el favicon de Puja.
 *
 * RESTAURAR AL DESMONTAR NO ES OPCIONAL: el micrositio y el panel son la misma
 * SPA, y sin esto el productor que vuelve al panel se queda con el ícono de su
 * remate en la pestaña.
 *
 * ⚠️ Sólo se ve con el micrositio abierto directo. Incrustado en el sitio del
 * productor, la pestaña es del sitio de AFUERA y desde el iframe no se puede
 * cambiar: lo de acá corre igual, pero nadie lo ve.
 */
const useFaviconMicrositio = (url) => {
  useEffect(() => {
    if (!url) return undefined;
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return undefined;
    const original = link.getAttribute('href');
    link.setAttribute('href', url);
    // Sin href original, se quita: `setAttribute('href', null)` escribiría el
    // texto "null" como ícono.
    return () => (original == null ? link.removeAttribute('href') : link.setAttribute('href', original));
  }, [url]);
};

export default useFaviconMicrositio;
